module.exports = __webpack_public_path__ + "assets/img/5ed3099f44e7c4ea00648a15c3e90cb3.svg";